
import React from 'react';
import Button from '../../../components/base/Button';
import { useTranslation } from 'react-i18next';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Modern%20software%20development%20office%20with%20professional%20team%20working%20on%20computers%2C%20clean%20minimalist%20workspace%20with%20large%20windows%2C%20natural%20lighting%2C%20contemporary%20design%2C%20technology%20atmosphere%2C%20blue%20and%20white%20color%20scheme%2C%20professional%20business%20environment&width=1920&height=1080&seq=hero-bg-001&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-6 relative z-10">
        <div className="w-full max-w-4xl">
          <div className="text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              {t('hero.title1')}
              <br />
              <span className="text-blue-400">{t('hero.title2')}</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
              {t('hero.desc1')}
              <br />
              {t('hero.desc2')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={scrollToContact}
                variant="primary"
                size="lg"
                className="bg-blue-600 hover:bg-blue-700"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-fill"></i>
                </div>
                {t('cta.freeConsult')}
              </Button>
              <Button 
                onClick={scrollToServices}
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-gray-900"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-arrow-right-line"></i>
                </div>
                {t('hero.learn')}
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
